/**
* description:
* Mutation types for App Vuex Module
*
* data : 2017-08-08
*/

export const FILL_GLOBAL_SETTINGS_DICTIONARY = 'FILL_GLOBAL_SETTINGS_DICTIONARY';
export const TOGGLE_PENDING_STORE_ACTIONS = 'TOGGLE_PENDING_STORE_ACTIONS';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
